export default "__VITE_PUBLIC_ASSET__54160711__"